export const isValidUsername = (str: string) => {
  return ['admin', 'editor'].indexOf(str.trim()) >= 0;
};

export const isExternal = (path: string) => {
  return /^(https?:|mailto:|tel:)/.test(path);
};

export const formatChannels = (str: string) => {
  const matcher = Array.from(new Set(str.match(/[^a-zA-Z0-9]/g)));
  if (matcher.length) {
    for (const key in matcher) {
      if (Object.prototype.hasOwnProperty.call(matcher, key)) {
        const element = matcher[key];
        // @ts-ignore
        str = str.replaceAll(element, '-');
      }
    }
  }
  return Array.from(new Set(str.split('-')));
};
